export const URL = window.configs.URL;
export const API_URL = window.configs.API_URL;
export const API_KEY = window.configs.API_KEY;
export const TICKET_ENDPOINT = window.configs.TICKET_ENDPOINT;
export const FILTER_SERVICE = window.configs.FILTER_SERVICE;
export const RATING = window.configs.RATING;
export const THEME = window.configs.THEME;
export const DEBUG = window.configs.DEBUG;


// WEBPACK FOOTER //
// ./src/configs/global.js